export default "__VITE_ASSET__DiaiZTaw__"